import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSliderModule } from '@angular/material/slider';
import { BrowserModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { DateComponent } from './date/date.component';
import { DialogComponent } from './dialog/dialog.component';
import { FreeTextComponent } from './free-text/free-text.component';
import { GenericDisplayComponent } from './generic-display/generic-display.component';
import { HourComponent } from './hour/hour.component';
import { MultipleChoicesComponent } from './multiple-choices/multiple-choices.component';
import { QuantityComponent } from './quantity/quantity.component';
import { SmileyComponent } from './smiley/smiley.component';
import { SurveyDisplayComponent } from './survey-display.component';
import { UniqueChoiceComponent } from './unique-choice/unique-choice.component';
import { YearComponent } from './year/year.component';
import { YesOrNoComponent } from './yes-or-no/yes-or-no.component';
import { BtnSaveComponent } from './btn-save/btn-save.component';
import { LengthOfTimeComponent } from './length-of-time/length-of-time.component';
import { TranslatorModule } from './translator/translator.module';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    SurveyDisplayComponent,
    MultipleChoicesComponent,
    UniqueChoiceComponent,
    QuantityComponent,
    SurveyDisplayComponent,
    GenericDisplayComponent,
    FreeTextComponent,
    DateComponent,
    YesOrNoComponent,
    YearComponent,
    HourComponent,
    SmileyComponent,
    DialogComponent,
    BtnSaveComponent,
    LengthOfTimeComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    BrowserModule,
    NoopAnimationsModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatListModule,
    MatInputModule,
    MatDatepickerModule,
    FormsModule,
    MatSliderModule,
    MatNativeDateModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    TranslatorModule,
    HttpClientModule
  ],
  providers: [
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS, 
      useValue: {hasBackdrop: false}
    }
  ],
  exports: [SurveyDisplayComponent]
})
export class SurveyAnswerModule { }
